var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcRemovePet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM8.46448 7.05027C8.07396 6.65974 7.44079 6.65974 7.05027 7.05027C6.65974 7.44079 6.65974 8.07396 7.05027 8.46448L10.5858 12L7.05027 15.5355C6.65974 15.9261 6.65974 16.5592 7.05027 16.9498C7.44079 17.3403 8.07396 17.3403 8.46448 16.9498L12 13.4142L15.5355 16.9498C15.9261 17.3403 16.5592 17.3403 16.9498 16.9498C17.3403 16.5592 17.3403 15.9261 16.9498 15.5355L13.4142 12L16.9498 8.46448C17.3403 8.07396 17.3403 7.44079 16.9498 7.05027C16.5592 6.65974 15.9261 6.65974 15.5355 7.05027L12 10.5858L8.46448 7.05027Z",
    fill: "#ADADAD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRemovePet);
export default __webpack_public_path__ + "static/media/ic_remove_pet.d8c757a48df9ad3742023d717a7089af.svg";
export { ForwardRef as ReactComponent };